import React, { useMemo, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Breadcrumbs from '../../components/Common/Breadcrumb';
import TableContainer from '../../components/Common/TableContainer';
import { getVisit, getVisitsByClinicId } from "service/api";
import Preloader from "components/Preloader/Preloader";
import { jwtDecode } from 'jwt-decode';

// import DeleteConfirmationModal from "./DeleteConfirmationModal"
import axios from 'axios';


function DatatableTables() {
    const [alluserlist, setallusers] = useState({ users: [] });
    // const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)
    // const [selectedDeleteData, setSelectedDeleteData] = useState(null)
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getallusers();
    }, []);



    const getallusers = async () => {
        try {
            const token = localStorage.getItem("token");

            let response;
            if (token) {
                const decoded = jwtDecode(token);
                const clinicID = decoded?.clinicID;

                if (clinicID) {
                    // Call getVisitsByClinicId if clinicID exists in token
                    response = await getVisitsByClinicId(clinicID);
                } else {
                    // Default fallback if no clinicID
                    response = await getVisit();
                }

                if (response.error) {
                    console.log('Error while fetching data:', response.error);
                } else {
                    // setallusers({ users: response.data });
                    setallusers({ users: [...response.data].reverse() });
                }
            }
        } catch (error) {
            console.log("Error while fetching data:", error);
        } finally {
            setLoading(false);
        }
    };

    const columns = useMemo(
        () => [
            {
                Header: 'Sr. No.',
                accessor: (_row, i) => i + 1,
                id: 'srno',
                Cell: ({ value }) => <span style={{ fontWeight: '600', color: '#888' }}>{value}</span>,
            },
            {
                Header: 'Visit No.',
                accessor: 'visit_no',
            },
            {
                Header: 'Title',
                accessor: 'title',
            },
            {
                Header: 'First Name',
                accessor: 'firstname'
            },
            {
                Header: 'Last Name',
                accessor: 'lastname'
            },
            {
                Header: 'Age',
                accessor: 'age'
            },
            {
                Header: 'Email',
                accessor: 'email'
            },
            {
                Header: 'Mobile',
                accessor: 'clinicmobile'
            },
            // {
            //     Header: "Action",
            //     accessor: row => {
            //         const id = row?._id
            //         return (
            //             <>
            //                 {/* <button className="btn btn-danger mx-2"
            //                 // onClick={() => openDeleteModal(id)}
            //                 > <i className="mdi mdi-trash-can font-size-15"></i> </button> */}
            //             </>
            //         )
            //     },
            // },
        ],
        []
    );
    //meta title
    document.title = "Visit | List";

    return (
        <div className="page-content">
            <div className="container-fluid">
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h1 className="page-title"></h1>
                    <Link to="/Addvisit" className="btn btn-primary">ADD NEW VISIT</Link>
                </div>
                <Breadcrumbs title="Setting" breadcrumbItem="Visit" />
                <div>
                    <TableContainer
                        columns={columns}
                        data={alluserlist.users}
                        isGlobalFilter={true}
                        isAddOptions={false}
                        customPageSize={10}
                        className="custom-header-css"
                    />
                    {loading && <Preloader />}
                </div>
                {/* <DeleteConfirmationModal
          isOpen={isDeleteModalOpen}
          onClose={closeDeleteModal}
          onConfirm={handleDelete}
        /> */}
            </div>
        </div>
    );
}

export default DatatableTables;